export const getProductUrl = (t, productSlug) => {
	return `/${t("produkt")}/${productSlug}`
}
